const site = {
  OPOPULAR: {
    name: 'opopular.d',
    slug: 'opopular'
  },
  DAQUI: {
    name: 'daqui.d',
    slug: 'daqui'
  },
  CBNGO: {
    name: 'cbngo.d',
    slug: 'cbngo'
  },
  CBNTO: {
    name: 'cbnto.d',
    slug: 'cbnto'
  },
  TOCANTINS: {
    name: 'tocantins.d',
    slug: 'tocantins'
  },
}

function getSiteData(siteSlug) {
  switch (siteSlug) {
    case 'opopular':
      return site.OPOPULAR
    case 'daqui':
      return site.DAQUI
    case 'cbngo':
      return site.CBNGO
    case 'cbnto':
      return site.CBNTO
    case 'tocantins':
      return site.TOCANTINS
    default:
      return {
        name: ""
      }
  }
}

export { site, getSiteData }
